import { ExchangeAuthCodeForJwt } from 'api/security-endpoint';
import { EXECUTIONS, LOGIN } from 'navigator/links';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function LoginWithIdpPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get('code');

    const exchangeCode = async () => {
      if (code) {
        setLoading(true);
        try {
          const loginResponse = await ExchangeAuthCodeForJwt(code);
          if (loginResponse.loginSuccessful) {
            navigate(EXECUTIONS);
          } else {
            console.error('Failed to exchange auth code for jwt: ', loginResponse.errorMessage);
            navigate(LOGIN + '?message=Failed to login with external Identity Provider. If this issue persists contact an admin.');
          }
        } catch (error) {
          console.error('Error exchanging code for JWT: ', error);
          navigate(LOGIN + '?message=Failed to login with external Identity Provider. If this issue persists contact an admin.');
        }
        setLoading(false);
      } else {
        console.error('No auth code in URL query parameters');
        navigate(LOGIN);
      }
    };

    exchangeCode();
  }, [location]);

  return (
    <div>
      <>{loading ? <div>Loading...</div> : <></>}</>
      Authorizing with the KSDE Validation Portal...
    </div>
  );
}
